// packages/api/src/hooks/useTour.ts
//
// Phase 01 W3.7-polish (2026-05-13) — Tour completion mutation.

import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import type { ApiSuccess } from '@alamo/types';

import { apiClient } from '../client';
import { queryKeys } from '../query-keys';

export interface TourConfig {
  enabled: boolean;
}

export function useTourConfig(enabled: boolean) {
  return useQuery({
    queryKey: queryKeys.profile.tourConfig(),
    queryFn: async (): Promise<TourConfig> => {
      const response = await apiClient.get<ApiSuccess<TourConfig>>('/profile/tour-config');
      return response.data.data;
    },
    enabled,
    retry: false,
    staleTime: 5 * 60 * 1000,
  });
}

interface MarkTourCompletedResponse {
  tourCompletedAt: string;
}

export function useMarkTourCompleted() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async () => {
      const res = await apiClient.post<{ data: MarkTourCompletedResponse }>(
        '/profile/tour-completed',
      );
      return res.data.data;
    },
    onSuccess: () => {
      // refresh /auth/me so the cached user picks up the new field
      queryClient.invalidateQueries({ queryKey: ['auth', 'me'] });
    },
  });
}
